/* eslint-disable no-unused-vars */
import Flickity from 'flickity';

function flickityPartnersSlide () {
    const blocks = document.querySelectorAll( '.wp-block-leanpathblocks-partners-grid' )
    if ( !blocks.length ) return

    blocks.forEach( ( block ) => {
        const items = block.querySelectorAll( '.partner-item' )
        if ( !items.length ) return

        const holder = block.querySelector( '.wp-block-leanpathblocks-partners-grid__grid' )
        const flickity = new Flickity( holder, {
            prevNextButtons: false,
            cellAlign: 'left',
            groupCells: false,
            imagesLoaded: true,
            pageDots: false,
            percentPosition: true,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            cellSelector: '.partner-item',
            selectedAttraction: 0.05,
            wrapAround: false,
            friction: 0.5,
            adaptiveHeight: false,
            draggable: true,
            watchCSS: true,
            contain: true,
        } );
    } )
}

flickityPartnersSlide ()